import { render, staticRenderFns } from "./ShowDocument.vue?vue&type=template&id=3c37d6f7&"
import script from "./ShowDocument.vue?vue&type=script&lang=js&"
export * from "./ShowDocument.vue?vue&type=script&lang=js&"
import style0 from "./ShowDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c37d6f7')) {
      api.createRecord('3c37d6f7', component.options)
    } else {
      api.reload('3c37d6f7', component.options)
    }
    module.hot.accept("./ShowDocument.vue?vue&type=template&id=3c37d6f7&", function () {
      api.rerender('3c37d6f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/document/ShowDocument.vue"
export default component.exports